// extracted by mini-css-extract-plugin
export default {"wrapper":"BD-z","viewport":"CD-z","container":"DD-z","slide":"ED-z"};